var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{style:(_vm.styles),attrs:{"dark":_vm.dark,"id":_vm.id,"disabled":_vm.disabled,"color":_vm.color,"size":_vm.size}},[_vm._v(_vm._s(_vm.classPrefix)+" "+_vm._s(_vm.iconClass))])
}
var staticRenderFns = []

export { render, staticRenderFns }